import Vue from "vue";
import { createRouter, createWebHistory } from 'vue-router'
import store from "../store";

// Public
import MainPage from            '@/views/public/index.vue'
import Auth from                '@/views/public/auth.vue'
import NotFound from            '@/views/public/notfound.vue'
import Denied from              '@/views/public/denied.vue'
import Logout from              '@/views/public/logout.vue'
import ClientKyc from           '@/views/public/client_kyc.vue'

// Personal
import PersonalClients from     '@/views/personal/clients.vue'
import PersonalOrders from      '@/views/personal/orders.vue'
import PersonalSubscriptions from '@/views/personal/subscriptions.vue'
import PersonalWalletDetail from '@/views/personal/wallet.vue'
import PersonalAccountDetail from '@/views/personal/account.vue'

// Admin
import AdminUsers from          '@/views/admin/user/list.vue'
import AdminUserDetail from     '@/views/admin/user/detail.vue'
import AdminOrders from         '@/views/admin/orders.vue'
// import AdminMerchants from      '@/views/admin/merchants.vue'
import AdminClients from        '@/views/admin/clients.vue'
import AdminWallets from        '@/views/admin/wallet/list.vue'
import AdminWalletDetail from   '@/views/admin/wallet/detail.vue'
import AdminAccounts from       '@/views/admin/account/list.vue'
import AdminAccountDetail from  '@/views/admin/account/detail.vue'
import AdminOperations from     '@/views/admin/operation/list.vue'
import AdminTransactions from   '@/views/admin/transaction/list.vue'
import AdminSubscriptions from  '@/views/admin/subscription/list.vue'
import AdminSubscriptionEvents from  '@/views/admin/subscription/event_list.vue'
import AdminSubscriptionAttempts from  '@/views/admin/subscription/attempt_list.vue'
import AdminRates from          '@/views/admin/rates/list.vue'
import AdminRateDetail from     '@/views/admin/rates/detail.vue'

function isUserInGroup (group, objGroups) { 
    if(!group) return false
    if(!objGroups) return false
    let groups = [], in_group = false
    if(objGroups && typeof(objGroups) == 'object') groups = Array.from(objGroups) 
    else return false
    if(groups.includes(group)) in_group = true
    return (in_group) ? true : false
}

const routes = [
    {
        path: '/',
        name: 'Main Page',
        component: MainPage,
        meta: {
            requiresAuth: false,
            leftMenuType: 'public',
            requireAccessCodes: [],
            title: 'Main Page',
            title_ru: 'Главная',
            icon: 'pi pi-home',
            sort: 1
        }
    },
    {
        path: '/auth/',
        name: 'Auth',
        component: Auth,
        meta: {
            requiresAuth: false,
            requireAccessCodes: [],
            title: 'Auth',
            title_ru: 'Авторизация',
            icon: 'pi pi-sign-in',
            sort: 2
        }
    },
    {
        path: '/logout/',
        name: 'Logout',
        component: Logout,
        meta: {
            requiresAuth: false,
            requireAccessCodes: [],
            title: 'Logout',
            title_ru: 'Выход',
            icon: 'pi pi-sign-out',
            sort: 3
        }
    },
    {
        path: '/kyc/:user_login/:kyc_type',
        name: 'KYC',
        component: ClientKyc,
        meta: {
            requiresAuth: false,
            requireAccessCodes: [],
            title: 'KYC',
            title_ru: 'KYC',
            icon: 'pi pi-id-card',
            sort: 2
        }
    },

    // Personal
    {
        path: '/personal/orders/',
        name: 'Personal Orders',
        component: PersonalOrders,
        meta: {
            requiresAuth: true,
            leftMenuType: 'personal',
            requireAccessCodes: [],
            title: 'Orders',
            title_ru: 'Инвойсы',
            icon: 'pi pi-file',
            sort: 4,
            external: true
        }
    },
    {
        path: '/personal/clients/',
        name: 'Personal Clients',
        component: PersonalClients,
        meta: {
            requiresAuth: true,
            leftMenuType: 'personal',
            requireAccessCodes: [],
            title: 'Clients',
            title_ru: 'Клиенты',
            icon: 'pi pi-users',
            sort: 5,
            external: true
        }
    },
    {
        path: '/personal/subscriptions/',
        name: 'Personal Subscriptions',
        component: PersonalSubscriptions,
        meta: {
            requiresAuth: true,
            leftMenuType: 'personal',
            requireAccessCodes: ['personal_subscriptions'],
            title: 'Subscriptions',
            title_ru: 'Подписки',
            icon: 'pi pi-book',
            sort: 6,
            external: true
        }
    },
    {
        path: '/personal/wallet/',
        name: 'Personal Wallet Detail',
        component: PersonalWalletDetail,
        meta: {
            requiresAuth: true,
            leftMenuType: 'personal',
            requireAccessCodes: [],
            title: 'Personal Wallet',
            title_ru: 'Кошелек',
            icon: 'pi pi-wallet',
            external: true,
            sort: 7
        }
    },
    {
        path: '/personal/account/:id',
        name: 'Personal Account Detail',
        component: PersonalAccountDetail,
        meta: {
            requiresAuth: true,
            leftMenuType: null,
            requireAccessCodes: [],
            title: 'Personal Account Detail',
            title_ru: 'Детали аккаунта',
            sort: 8
        }
    },

    // Admin
    {
        path: '/admin/users/',
        name: 'Admin Users',
        component: AdminUsers,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_users'],
            title: 'Admin Users',
            title_ru: 'Мерчанты',
            icon: 'pi pi-users',
            sort: 6,
            external: true
        }
    },
    {
        path: '/admin/user/:id',
        name: 'Admin User Detail',
        component: AdminUserDetail,
        meta: {
            requiresAuth: true,
            leftMenuType: null,
            requireAccessCodes: ['super_admin'],
            title: 'Admin User Detail',
            title_ru: 'Детали пользователя',
            sort: 7
        }
    },
    {
        path: '/admin/orders/',
        name: 'Admin Orders',
        component: AdminOrders,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_orders'],
            title: 'Admin Orders',
            title_ru: 'Инвойсы',
            icon: 'pi pi-file',
            sort: 7,
            external: true
        }
    },
    {
        path: '/admin/wallets/',
        name: 'Admin Wallets',
        component: AdminWallets,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_wallets'],
            title: 'Admin Wallets',
            title_ru: 'Кошельки',
            icon: 'pi pi-wallet',
            sort: 7,
            external: true
        }
    },
    {
        path: '/admin/wallet/:id',
        name: 'Admin Wallet Detail',
        component: AdminWalletDetail,
        meta: {
            requiresAuth: true,
            leftMenuType: null,
            requireAccessCodes: ['admin', 'admin_wallets'],
            title: 'Admin Wallet Detail',
            title_ru: 'Детали кошелька',
            sort: 8
        }
    },
    {
        path: '/admin/accounts/',
        name: 'Admin Accounts',
        component: AdminAccounts,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_accounts'],
            title: 'Admin Accounts',
            title_ru: 'Счета',
            icon: 'pi pi-credit-card',
            sort: 7,
            external: true
        }
    },
    {
        path: '/admin/account/:id',
        name: 'Admin Account Detail',
        component: AdminAccountDetail,
        meta: {
            requiresAuth: true,
            leftMenuType: null,
            requireAccessCodes: ['admin', 'admin_accounts'],
            title: 'Admin Account Detail',
            title_ru: 'Детали аккаунта',
            sort: 8
        }
    },
    {
        path: '/admin/operations/',
        name: 'Admin Operations',
        component: AdminOperations,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_operations'],
            title: 'Admin Operations',
            title_ru: 'Операции',
            icon: 'pi pi-cog',
            sort: 7,
            external: true
        }
    },
    {
        path: '/admin/transactions/',
        name: 'Admin Transactions',
        component: AdminTransactions,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_transactions'],
            title: 'Admin Transactions',
            title_ru: 'Транзакции',
            icon: 'pi pi-receipt',
            sort: 8,
            external: true
        }
    },
    {
        path: '/admin/clients/',
        name: 'Admin Clients',
        component: AdminClients,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_clients'],
            title: 'Admin Clients',
            title_ru: 'Клиенты',
            icon: 'pi pi-users',
            sort: 9,
            external: true
        }
    },
    {
        path: '/admin/subscriptions/',
        name: 'Admin Subscriptions',
        component: AdminSubscriptions,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_subscriptions'],
            title: 'Admin Subscriptions',
            title_ru: 'Подписки',
            icon: 'pi pi-book',
            sort: 10,
            external: true
        }
    },
    {
        path: '/admin/subscriptions/events/',
        name: 'Admin Subscription Events',
        component: AdminSubscriptionEvents,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_subscriptions'],
            title: 'Admin Subscription Events',
            title_ru: 'События подписок',
            icon: 'pi pi-calendar',
            sort: 11,
            external: true
        }
    },
    {
        path: '/admin/subscriptions/attempts/',
        name: 'Admin Subscription Attempts',
        component: AdminSubscriptionAttempts,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin', 'admin_subscriptions'],
            title: 'Admin Subscription Attempts',
            title_ru: 'Попытки подписок',
            icon: 'pi pi-clock',
            sort: 12,
            external: true
        }
    },
    {
        path: '/admin/rates/',
        name: 'Admin Rates',
        component: AdminRates,
        meta: {
            requiresAuth: true,
            leftMenuType: 'admin',
            requireAccessCodes: ['admin'],
            title: 'Admin Rates',
            title_ru: 'Курсы',
            icon: 'pi pi-chart-line',
            sort: 13,
            external: true
        }
    },
    {
        path: '/admin/rates/:id',
        name: 'Admin Rate Detail',
        component: AdminRateDetail,
        meta: {
            requiresAuth: true,
            leftMenuType: null,
            requireAccessCodes: ['admin'],
            title: 'Admin Rate Detail',
            title_ru: 'Детали курса',
            sort: 14
        }
    },
    
    // SYSTEM
    {
        path: '/denied/',
        name: 'Access denied',
        component: Denied,
        meta: {
            requiresAuth: false,
            requireAccessCodes: [],
            title: 'Access denied',
            title_ru: 'Доступ запрещен',
        }
    },
    {
        path: '/:pathMatch(.*)*',
        component: NotFound,
        name: 'Not found',
        meta: {
            requiresAuth: false,
            requireAccessCodes: [],
            title: 'Not found',
            title_ru: 'Страница не найдена',
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    // base: process.env.BASE_URL,
    mode: 'history',
    routes
})

//меняем мета данные на лету
router.beforeEach((to, from, next) => {
    window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
    if(store.getters.StateLang=='ru'){
        document.title = (to.meta.title_ru) ? to.meta.title_ru : (to.meta.title) ? to.meta.title : 'QRhub'
    }else{
        document.title = (to.meta.title) ? to.meta.title : 'QRhub'
    }
    next()
});


router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresMerchant)) {
        if (store.getters.isAuthenticated && isUserInGroup('merchant', store.getters.StateGroups)) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresManager)) {
        if (store.getters.isAuthenticated && (isUserInGroup('manager', store.getters.StateGroups) || isUserInGroup('admin', store.getters.StateGroups))) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAdmin)) {
        if (store.getters.isAuthenticated && isUserInGroup('admin', store.getters.StateGroups)) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requireAccessCodes)) {
        const requireAccessCodes = to.meta.requireAccessCodes;
        if (!requireAccessCodes || requireAccessCodes.length === 0) {
            next();
            return;
        }
        const userAccessCodes = store.getters.StateUserAccessCodes;
        const hasAccess = requireAccessCodes.every(code => userAccessCodes.includes(code));
        if (hasAccess) {
            next();
            return;
        }
        next("/denied/");
    } else {
        next();
    }
})

export default router;